// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"320":"ec82b1e365cbab8b","669":"767a1201f5e70e02"}[chunkId] + ".js";
};